/** Same destination for portal toasts and operating-system notifications. */
export type MonitoringNotificationAddress = {
  team_hub_channel_id?: string | null
  chat_id?: string | null
  topic_top_message_id?: number | null
}

export function monitoringRoomTarget(search: string): { chatId: string; topicId: number | null } | null {
  const params = new URLSearchParams(search)
  const chatId = (params.get('chat') || '').trim()
  if (!/^-?\d+$/.test(chatId)) return null
  const rawTopic = params.get('topic') || ''
  const value = /^\d+$/.test(rawTopic) ? Number(rawTopic) : 0
  return { chatId, topicId: Number.isSafeInteger(value) && value > 0 ? value : null }
}

export function monitoringNotificationLink(item: MonitoringNotificationAddress, isAdmin: boolean): string {
  const prefix = isAdmin ? '/admin' : '/employee'
  const channel = String(item.team_hub_channel_id || '').trim()
  const linkedClient = channel.startsWith('client:') && channel.length > 'client:'.length
  const params = new URLSearchParams()
  if (linkedClient) {
    params.set('channel', channel)
    params.set('view', 'monitoring')
  }
  const target = monitoringRoomTarget(new URLSearchParams({
    chat: String(item.chat_id || ''),
    topic: String(item.topic_top_message_id || ''),
  }).toString())
  if (target) {
    params.set('chat', target.chatId)
    if (target.topicId) params.set('topic', String(target.topicId))
  }
  // An unlinked chat has no client tab in Slack; keep its exact monitoring address.
  const base = `${prefix}/${linkedClient ? 'slack' : 'monitoring_tg'}`
  return params.size ? `${base}?${params.toString()}` : base
}
